// The generic labeled sidebar-group shell — a flow-y group with a
// caption-title header that reads its `label` prop. Promoted VERBATIM from
// tickets/components/Sidebar.js's TicketsSidebarGroup (WS-SUITE-RED-
// BASELINE-1, 2026-08-18): canvas referenced `extends:
// 'TicketsSidebarGroup'` from FIVE sites (ProjectCanvasSidebar ×4, the
// studios TypeFilterGroup), which resolves in the workspace SHELL (it
// merges every feature package) but NOT in the standalone canvas app —
// canvas's sharedLibraries are brand/shared/monaco/preview/marketplace,
// no tickets — so the group chrome silently degraded there. Cross-app
// component imports are banned (eslint no-restricted-imports: "use
// shared/components instead"), so the shell lives HERE, where every
// package's registry already reaches. The tickets-local
// `TicketsSidebarGroup` remains for tickets' own call sites; folding it
// into `extends: 'AppSidebarGroup'` is its owning lane's one-liner.
export const AppSidebarGroup = {
  flow: 'y',
  gap: 'Z',
  marginBottom: 'A',

  Header: {
    flow: 'x',
    align: 'center left',
    padding: 'V 0',

    // THE EYEBROW (brief §4.3 item 3, P44): the `Y` role (11.8px at the 17px
    // root), 500, uppercase, `inactive` — the brand CaptionTitle brings the
    // uppercase and the `inactive` ink (6.38:1 measured on the dark card);
    // this sets the size and weight. The size is written `Z`, not `Y`:
    // typography tokens are em-relative and every rail sets `fontSize: 'Z'`
    // (14.17px), where `Y` renders 9.84px — under the brief's own 11.8px
    // floor (G11) — and `Z` renders 11.81px, the `Y` role exactly (measured
    // live 2026-09-24; the old `Y2` was 11.05px). The label is a bundle key or a plain string: polyglot
    // returns a non-key verbatim, so both read right (TicketsSidebarGroup,
    // which this was promoted from, always translated it).
    CaptionTitle: {
      flex: '1',
      fontSize: 'Z',
      fontWeight: '500',
      Text: {
        text: (el) => el.call('polyglot', el.parent?.parent?.parent?.label || '')
      }
    }
  }
}
